// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1zWqq","dragIcon":"SortableItem_dragIcon__1bLtr","disabled":"SortableItem_disabled__1fngb"};